<form class="column gap" [formGroup]="userForm">
  <mat-toolbar class="center">
    <div class="row gap">
      <h5 class="top-bar-view-title full-width">{{ 'ReactivateUserComponent.reactivateUser' | translate }}</h5>
      <span class="fill-remaining-space"></span>
    </div>
    <span class="fill-remaining-space"></span>
  </mat-toolbar>
  <div class="column gap inputs">
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'InviteUserComponent.email' | translate }}
      </mat-label>
      <input matInput placeholder="{{ 'InviteUserComponent.email' | translate }}" type="text" formControlName="email" />
      <mat-error *ngIf="userForm.get('email')?.hasError('required')">{{
        'InviteUserComponent.requiredEmail' | translate
      }}</mat-error>
      <mat-error *ngIf="userForm.get('email')?.hasError('email')">{{
        'InviteUserComponent.invalidEmail' | translate
      }}</mat-error>
    </mat-form-field>
    <div class="row horizontal-end">
      <button mat-raised-button color="primary" [disabled]="userForm.invalid" (click)="reactivateUser()">
        {{ 'ReactivateUserComponent.reactivateUser' | translate }}
      </button>
    </div>
  </div>
</form>
